import React, { Component, Fragment } from "react"
import { Formik, Form, Field } from "formik"
import { withRouter } from "../../helpers/withRouter"
import {
  Row,
  ButtonGroup,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Card,
  CardBody,
  Col,
  Input,
} from "reactstrap"
import * as XLSX from "xlsx"
import ListPageHeader from "../../components/custom/ListPageHeader"
import ListPage from "../../components/custom/ListPage"
import { quizPageValidation } from "../../helpers/validations"
import { Message } from "../../helpers/language_helper"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { DateFormat, getDateTimeString } from "../../helpers/utils"
import { SuccessMessage, ErrorMessage } from "../../helpers/notifications"
import { QueryRequest, MutateRequest } from "../../helpers/service_helper"
import { timestampToDate, unixdateconversion } from "../../helpers/utils"
import {
  createQuizMasterMutation,
  updateQuizMasterMutation,
  deleteQuizMasterMutation,
  getAllQuizMasterQuery,
  getOneQuizMasterQuery,
  getAllAgeGroup,
} from "./Queries"
import { Helmet } from "react-helmet-async"

class QuizMaster extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentpage: 1,
      buttonAction: false,
      isLoading: true,
      pageSizeOptions: [25, 50, 100, 500],
      pageLimit: 25,
      totalCount: 0,
      keyField: "id",
      viewModal: false,
      quizMasterList: [],

      listRequestModel: {
        searchString: "",
        sortCondition: null,
        pageNumber: 1,
        pageLimit: 25,
      },
      quizMaster: {},
      columns: [
        {
          name: "Quiz Name",
          selector: row => row.name,
          sortable: true,
          cell: row => <span>{row.name ? row.name : ""}</span>,
        },
        {
          name: "Age Group",
          selector: row => row.ageGroup,
          sortable: true,
          cell: row => (
            <span>
              {row.ageGroupMaster?.ageGroupTitle
                ? row.ageGroupMaster?.ageGroupTitle
                : ""}
            </span>
          ),
        },
        {
          name: "From Date",
          selector: row => row.dateRange,
          sortable: true,
          cell: row => (
            <span>
              {row.dateRangeMin
                ? unixdateconversion(row.dateRangeMin, {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                  })
                : "-"}
            </span>
          ),
        },
        {
          name: "To Date",
          selector: row => row.dateRange,
          sortable: true,
          cell: row => (
            <span>
              {row.dateRangeMax
                ? unixdateconversion(row.dateRangeMax, {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                  })
                : "-"}
            </span>
          ),
        },

        /*{
          ame: "Age Group Id",
          selector: "ageGroupId",
          sortable: true,
          cell: row => <span>{row.ageGroupId ? row.ageGroupId : ""}</span>,
        },*/
        {
          name: "Action",
          selector: row => row.action,
          sortable: false,
          cell: row => (
            <Row>
              <ButtonGroup className="mb-2" style={{ top: "4px" }}>
                <Button
                  outline
                  color="primary"
                  className="mobileViewFont ms-2"
                  onClick={() => this.handleEdit(row)}
                >
                  {Message("edit")}
                </Button>

                <Button
                  outline
                  color="danger"
                  className="mobileViewFonts ps-1 pe-1 ms-2"
                  onClick={() => this.toggleDeleteModal(row)}
                >
                  {Message("delete")}
                </Button>
              </ButtonGroup>
            </Row>
          ),
        },
      ],
    }
  }

  componentDidMount() {
    this.getAllQuizMaster()
    this.getAllAgeGroup()
  }

  // ageGroupList = []
  getAllAgeGroup = async () => {
    await QueryRequest(getAllAgeGroup).then(res => {
      this.setState({
        ageGroupList: res.data?.getAllAgeGroupMasters?.items.map(function (a) {
          return { value: a.id, label: a.ageGroupTitle }
        }),
      })
    })
  }

  getAllQuizMaster = async value => {
    this.setState({
      isLoading: true,
    })
    const { listRequestModel } = this.state
    var values = listRequestModel
    const response = await QueryRequest(getAllQuizMasterQuery, values)
    var quizMastersValue = response?.data?.getAllQuizMasters?.items
    //console.log(quizMastersValue)
    if (quizMastersValue) {
      this.setState({
        isLoading: false,
        quizMasterList: quizMastersValue,
        totalPage:
          response?.data?.getAllQuizMasters?.pagination?.totalCount /
          response?.data?.getAllQuizMasters?.pagination?.pageLimit,
        totalCount: response?.data?.getAllQuizMasters?.pagination?.totalCount,
      })
    } else
      this.setState({
        isLoading: false,
      })
  }

  /** handle list page  start  */
  handleSort = (column, sortDirection) => {
    var sortObj = {}
    sortObj[column.selector] = sortDirection === "asc" ? "asc" : "desc"
    this.setState(
      {
        listRequestModel: {
          ...this.state.listRequestModel,
          sortCondition: sortObj,
        },
      },
      function () {
        this.getAllQuizMaster()
      }
    )
  }

  handlePerRowsChange = async perPage => {
    this.setState(
      {
        pageLimit: perPage,
        pageNumber: 1,
        listRequestModel: {
          ...this.state.listRequestModel,
          pageLimit: perPage,
          pageNumber: 1,
        },
      },
      async function () {
        this.getAllQuizMaster()
      }
    )
  }

  handlePageChange = async page => {
    this.setState(
      {
        pageNumber: page,
        listRequestModel: {
          ...this.state.listRequestModel,
          pageNumber: page,
        },
      },
      function () {
        this.getAllQuizMaster()
      }
    )
  }

  searchQueryChanged = search => {
    this.setState(
      {
        listRequestModel: {
          ...this.state.listRequestModel,
          searchString: search.target.value,
        },
      },
      function () {
        if (
          this.state.listRequestModel.searchString === "" ||
          this.state.listRequestModel.searchString.length > 2
        ) {
          this.getAllQuizMaster()
        }
      }
    )
  }

  handleEdit = row => {
    //console.log(row)
    if (row) {
      this.setState({
        quizMaster: {
          id: row.id,
          dateRangeMin: String(Number(row.dateRangeMin) / 1000),
          dateRangeMax: String(Number(row.dateRangeMax) / 1000),
          ageGroupId: row.ageGroupId,
          name: row.name,
        },
        manageModal: !this.state.manageModal,
        IsEdited: true,
        Label: "Edit",
      })
    }
  }
  HandleRowClicked = row => {
    this.props.history.push("/quiz-questions/" + row.id)
  }

  unixconvert = values => {
    return new Date(values).toLocaleString()
  }
  /** Submit Function Start */
  handleSubmit = async values => {
    //console.log(new Date(values.dateRangeMin).valueOf() / 1000)
    this.state.Label == "Add"
      ? this.addQuizMaster(values)
      : this.editQuizMaster(values)
    // //console.log(values)
    // const response = values.id
    //   ? await MutateRequest(updateQuizMasterMutation, values)
    //   : await MutateRequest(createQuizMasterMutation, values)
    // var quizMasterValue = response?.data
    // if (quizMasterValue && values.id) {
    //   SuccessMessage(Message("quizMaster.update")),
    //     this.setState({
    //       manageEditModal: !this.state.manageEditModal,
    //     })
    //   this.getAllQuizMaster()
    // } else {
    //   SuccessMessage(Message("quizMaster.add")),
    //     this.setState({
    //       manageModal: !this.state.manageModal,
    //     })
    //   this.getAllQuizMaster()
    // }
  }

  addQuizMaster = async values => {
    let Data = {
      dateRangeMin: values.dateRangeMin,
      dateRangeMax: values.dateRangeMax,
      ageGroupId: parseInt(values.ageGroupId),
      name: values.name,
    }

    await MutateRequest(createQuizMasterMutation, { data: Data })
      .then(res => SuccessMessage(Message("quizMaster.add")))
      .catch(e => ErrorMessage(e))
    this.setState({
      manageModal: !this.state.manageModal,
    })
    this.getAllQuizMaster()
  }

  editQuizMaster = async values => {
    let Data = {
      id: values.id,
      data: {
        dateRangeMin: values.dateRangeMin,
        dateRangeMax: values.dateRangeMax,
        ageGroupId: parseInt(values.ageGroupId),
        name: values.name,
      },
    }
    await MutateRequest(updateQuizMasterMutation, Data)
      .then(res => SuccessMessage(Message("quizMaster.update")))
      .catch(e => ErrorMessage(e))
    this.setState({
      manageModal: !this.state.manageModal,
    })
    this.getAllQuizMaster()
  }

  addBtnClick = () => {
    this.setState({
      quizMaster: { dateRangeMin: "", dateRangeMax: "" },
      manageModal: !this.state.manageModal,
      Label: "Add",
    })
  }

  toggleDeleteModal = row => {
    this.setState({
      deleteModal: !this.state.deleteModal,
      quizMaster: row,
    })
  }

  toggleManageModal = () => {
    this.setState({
      quizMaster: {},
      manageModal: !this.state.manageModal,
    })
  }

  deleteQuizMaster = async id => {
    var values = {
      id: id,
    }
    const response = await MutateRequest(deleteQuizMasterMutation, values)
    var quizMasterdeleteValue = response?.data
    if (quizMasterdeleteValue.deleteQuizMaster.status === "Success") {
      SuccessMessage(Message("quizMaster.delete"))
      this.getAllQuizMaster()
      this.setState({
        buttonAction: false,
        deleteModal: !this.state.deleteModal,
      })
    } else {
      ErrorMessage(Message("api.error"))
      this.setState({
        buttonAction: false,
      })
    }
  }

  toggleViewModal = url => {
    this.setState({
      viewModal: !this.state.viewModal,
      documentView: url,
      quizMasterDetail: url ? url : "",
    })
  }
  readExcel = file => {
    const promise = new Promise((resolve, reject) => {
      const fileReader = new FileReader()
      fileReader.readAsArrayBuffer(file)

      fileReader.onload = e => {
        const bufferArray = e.target.result

        const wb = XLSX.read(bufferArray, { type: "buffer" })

        const wsname = wb.SheetNames[0]

        const ws = wb.Sheets[wsname]

        const data = XLSX.utils.sheet_to_json(ws)

        resolve(data)
      }

      fileReader.onerror = error => {
        reject(error)
      }
    })

    promise.then(d => {
      console.log(d)
    })
  }

  render() {
    const initialValues = this.state.quizMaster
    const conditionalRowStyles = [
      {
        when: row => row,
        style: {
          "&:hover": {
            cursor: "pointer",
          },
        },
      },
    ]
    console.log("svdnl", this.state.ageGroupList)

    return (
      <Fragment>
        <Helmet>
          <title>{Message("title.quizMaster")}</title>
        </Helmet>
        <div className="page-content">
          <div className="container-fluid">
            <Card>
              <CardBody>
                <ListPageHeader
                  heading={`${"Home"}.${"Quiz"}`}
                  buttonText={Message("add.quizMaster")}
                  onTextChange={this.searchQueryChanged}
                  buttonClick={this.addBtnClick}
                  searchValue={this.state.listRequestModel.searchString}
                />
                <Row style={{ float: "right" }}></Row>

                <ListPage
                  conditionalRowStyles={conditionalRowStyles}
                  columns={this.state.columns}
                  data={this.state.quizMasterList}
                  keyField={this.state.keyField}
                  totalCount={this.state.totalCount}
                  pageSizeOptions={this.state.pageSizeOptions}
                  rowClicked={this.HandleRowClicked}
                  onSort={this.handleSort}
                  pageLimit={this.state.pageLimit}
                  rowsPerPageOnChange={this.handlePerRowsChange}
                  pageChange={this.handlePageChange}
                  isDataLoading={this.state.isLoading}
                  overFlowXRemoval={true}
                />
              </CardBody>
            </Card>
            <Modal
              isOpen={this.state.deleteModal}
              toggle={this.toggleDeleteModal}
            >
              <ModalHeader toggle={this.toggleDeleteModal}>
                {Message("delete.quizMaster")}
              </ModalHeader>

              <ModalBody>
                <Fragment>
                  <Row className="mb-1 mt-2">
                    <p className="ms-3 me-3 font-size-15">
                      {Message("delete.confirmation")}{" "}
                      <span>
                        {" "}
                        <strong>{this.state.quizMaster?.name}</strong>{" "}
                      </span>{" "}
                      {Message("quiz")} {" ?"}
                    </p>
                  </Row>
                </Fragment>
              </ModalBody>

              <ModalFooter>
                <FormGroup className="float-sm-right ">
                  <Button
                    type="submit"
                    color="primary"
                    onClick={() =>
                      this.deleteQuizMaster(this.state.quizMaster.id)
                    }
                  >
                    {Message("yes")}
                  </Button>
                  <Button
                    color="danger"
                    className="ms-2"
                    onClick={() => this.toggleDeleteModal()}
                  >
                    {Message("no")}
                  </Button>
                </FormGroup>
              </ModalFooter>
            </Modal>
            <Modal
              isOpen={this.state.manageModal}
              toggle={this.toggleManageModal}
              size="md"
            >
              <ModalHeader toggle={this.toggleManageModal}>
                {this.state.Label == "Add"
                  ? Message("add.quizMaster")
                  : Message("update.quizMaster")}
              </ModalHeader>
              <Formik
                initialValues={initialValues}
                validationSchema={quizPageValidation}
                onSubmit={this.handleSubmit}
                validateOnBlur={false}
                validateOnChange={false}
              >
                {({ errors, values, setFieldValue }) => (
                  <Form className="av-tooltip tooltip-label-bottom">
                    <ModalBody>
                      <Fragment>
                        <Row>
                          <Col lg="12" xl="12" sm="12" md="12" xs="12">
                            <FormGroup className="mt-2 form-group has-float-label">
                              {/*<DropDown
                                label="Quiz"
                                components={{
                                  Input: CustomSelectInput,
                                }}
                                labelClassName="requiredField"
                                className="react-select"
                                classNamePrefix="react-select"
                                isSearchable
                                isClearable={true}
                                value={
                                  values.ageGroupId &&
                                  (typeof values.ageGroupId === "string"
                                    ? this.state.ageGroupList.find(
                                        r => r.value === values.ageGroupId
                                      )
                                    : this.state.ageGroupList.find(
                                        r => r.value === values.ageGroupId
                                      ))
                                }
                                options={this.state.ageGroupList}
                                ClearAction={() => {
                                  setFieldValue(`ageGroupId`, "")
                                }}
                                Action={entity => {
                                  setFieldValue(
                                    `ageGroupId`,
                                    entity ? entity.value : ""
                                  )
                                }}
                                errors={errors?.ageGroupId}
                              />*/}
                              <Label className="requiredField">
                                {Message("name.quizMaster")}
                              </Label>
                              <Field
                                autoComplete="off"
                                className="form-control"
                                name="name"
                                type="text"
                              />
                              {errors.name && (
                                <div className="invalid-feedback d-block">
                                  {errors.name}
                                </div>
                              )}
                            </FormGroup>
                          </Col>
                          <Col lg="12" xl="12" sm="12" md="12" xs="12">
                            <FormGroup>
                              <Label className="requiredField">
                                {Message("ageGroup")}
                              </Label>
                              <Input
                                type="select"
                                name="age_group"
                                id="age_group"
                                autoComplete="off"
                                className="form-control"
                                defaultValue={this.state.quizMaster.ageGroupId}
                                onChange={event => {
                                  setFieldValue(
                                    "ageGroupId",
                                    event.target.value
                                  )
                                }}
                              >
                                {this.state.ageGroupList.map(option => (
                                  <option
                                    key={option.value}
                                    value={option.value}
                                  >
                                    {option.label}
                                  </option>
                                ))}
                              </Input>
                            </FormGroup>
                          </Col>
                          <Col lg="12" xl="12" sm="12" md="12" xs="12">
                            <FormGroup className="mt-2 form-group has-float-label">
                              <Label className="requiredField">
                                {Message("fromDate")}
                              </Label>

                              {/* <DatePicker
                                // startDate={this.state.startDateFrom}
                                selectsStart
                                endDate={this.state.startDateFrom}
                                components={{ Input: CustomSelectInput }}
                                className="form-control"
                                selected={this.state.Label==="Edit"?new Date(parseInt(values.dateRangeMin,10)):""}
                                //selected={this.state.Label==="Add"?values.dateRangeMin:""}
                                // value={new Date(
                                //   parseInt(values.dateRangeMin)
                                // ).toLocaleDateString()}
                                value={timestampToDate(values.dateRangeMin)}
                                isClearable={true}
                                maxDate={moment().fromNow()}
                                onChange={date => {
                                  if (date) setFieldValue(`dateRangeMin`, date)
                                  else setFieldValue(`dateRangeMin`, "")
                                }}
                                // placeholderText="From Date"
                                dateFormat="dd/MM/yyyy"
                              /> */}
                              <DatePicker
                                // autoComplete="off"
                                className="form-control box-border"
                                dateFormat="dd/MM/yyyy"
                                peekNextMonth
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                name="DateRange1"
                                selected={
                                  values.dateRangeMin
                                    ? new Date(
                                        Number(values.dateRangeMin) * 1000
                                      )
                                    : ""
                                }
                                onChange={date => {
                                  console.log(date)
                                  if (date)
                                    setFieldValue(
                                      `dateRangeMin`,
                                      (
                                        new Date(date).valueOf() / 1000
                                      ).toString()
                                    )
                                  else setFieldValue(`dateRangeMin`, "")
                                }}
                              />
                              {errors.dateRangeMin && (
                                <div className="invalid-feedback d-block">
                                  {errors.dateRangeMin}
                                </div>
                              )}
                            </FormGroup>
                          </Col>
                          <Col lg="12" xl="12" sm="12" md="12" xs="12">
                            <FormGroup className="mt-2 form-group has-float-label">
                              <Label className="requiredField">
                                {Message("toDate")}
                              </Label>

                              {/* <DatePicker
                                startDate={values.dateRangeMin}
                                selectsStart
                                // endDate={this.state.startDateFrom}
                                components={{ Input: CustomSelectInput }}
                                className="form-control"
                                selected={this.state.Label==="Edit"?new Date(parseInt(values.dateRangeMax,10)):""}
                                //selected={this.state.Label==="Add"?values.dateRangeMax:""}
                                value={timestampToDate(values.dateRangeMax)}
                                isClearable={true}
                                maxDate={moment().fromNow()}
                                onChange={date => {
                                  if (date) setFieldValue(`dateRangeMax`, date)
                                  else setFieldValue(`dateRangeMax`, "")
                                }}
                                // placeholderText="From Date"
                                dateFormat="dd/MM/yyyy"
                              /> */}
                              <DatePicker
                                // autoComplete="off"
                                className="form-control box-border"
                                dateFormat="dd/MM/yyyy"
                                peekNextMonth
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                name={"DateRange2"}
                                selected={
                                  values.dateRangeMax
                                    ? new Date(
                                        Number(values.dateRangeMax) * 1000
                                      )
                                    : ""
                                }
                                onChange={date => {
                                  if (date)
                                    setFieldValue(
                                      `dateRangeMax`,
                                      (
                                        new Date(date).valueOf() / 1000
                                      ).toString()
                                    )
                                  else setFieldValue(`dateRangeMax`, "")
                                }}
                              />
                              {errors.dateRangeMax && (
                                <div className="invalid-feedback d-block">
                                  {errors.dateRangeMax}
                                </div>
                              )}
                            </FormGroup>
                          </Col>
                          {/*<Col lg="12" xl="12" sm="12" md="12" xs="12">
                            <FormGroup className="mt-2 form-group has-float-label">
                              <Label className="">Question</Label>
                              <FormGroup>
                                <textarea
                                  type="text"
                                  className="form-control form-control-sm"
                                  rows="3"
                                  name="question"
                                  value={values.question}
                                  onChange={e =>
                                    setFieldValue("question", e.target.value)
                                  }
                                />
                              </FormGroup>
                              {errors.question && (
                                <div className="invalid-feedback d-block">
                                  {errors.question}
                                </div>
                              )}
                            </FormGroup>
                              </Col>*/}
                        </Row>
                      </Fragment>
                    </ModalBody>

                    <ModalFooter>
                      <div className="container-fluid">
                        <Row>
                          <Col sm={6} className="required">
                            &nbsp;{Message("mandatoryFields")}
                          </Col>
                          <Col sm={6}>
                            <div className="text-sm-right d-none d-sm-block">
                              <FormGroup className="float-sm-right ">
                                <Button type="submit" color="primary">
                                  {this.state.Label == "Edit"
                                    ? "Update"
                                    : "Add"}
                                </Button>

                                <Button
                                  color="danger"
                                  className="ms-2"
                                  onClick={() => this.toggleManageModal()}
                                >
                                  {Message("cancel")}
                                </Button>
                              </FormGroup>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </ModalFooter>
                  </Form>
                )}
              </Formik>
            </Modal>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default withRouter(QuizMaster)
